import { Component, OnInit } from "@angular/core";
import {
  FormGroup,
  FormBuilder,
  FormControl,
  Validators,
} from "@angular/forms";
import { XlsxService } from 'src/app/services/xlsx/xlsx.service';
import { CartonProvider } from "../../shared/providers/carton.provider";
import { AdminDataProvider } from '../../shared/providers/master-provider/admin-data.provider';
import { CartonModel } from "../../shared/models/carton";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { Router } from "@angular/router";
import { ToastClientService } from "src/app/services/toast/toast-client.service";
import { ApiService } from "../../../services/http/api.service";
import { ApiConfiguration } from "../../../services/http/api-configuration";
import { FrequencyProvider } from "../../shared/providers/frequency.provider";

@Component({
  selector: 'app-crown-list',
  templateUrl: './crown-list.component.html',
  styleUrls: ['./crown-list.component.scss']
})
export class CrownListComponent implements OnInit {
  addOrEditCarton: string;
  cartons = [];
  title = "modal2";
  formGroup;
  deletePopupUiData;
  frequencyList: any = [];
  formData: any = {};
  voucherCodes: any =[];
  editProfileForm: FormGroup;
  submitted : boolean = false
  brandList : any = []
  page = 1;
  getPaginationCount;
  startDate : any = ""
  countError : boolean = false;
  constructor(
    private fb: FormBuilder,
    public cartonProviders: CartonProvider,
    public adminDataProvider: AdminDataProvider,
    private modalService: NgbModal,
    private router: Router,
    private xlsx: XlsxService,
    private toast: ToastClientService,
    private apiService: ApiService,
    private apiConfig: ApiConfiguration,
    public frequencyProvider: FrequencyProvider,
  ) { }

  ngOnInit() { 
    this.formGroup = this.fb.group({
      carton_title : new FormControl("", [Validators.required, Validators.pattern('[A-Za-z0-9 ]*')]),
      brand: new FormControl("", [Validators.required]),
      count: new FormControl("", [Validators.required, Validators.pattern('[0-9]*')]),
      start_date: new FormControl("", [Validators.required]),
      end_date: new FormControl("", [Validators.required]),
    });
    this.getBrand();
    this.getCrownList();
  }

  ngDoCheck() {

  }
  
  getCrownList(){
    this.apiService.getHeaders(this.apiConfig.crownList +`?page_no=${this.page}`).subscribe((res : any)=>{
      console.log(res);
      this.cartons = res.body.data.data.pagination;
      this.getPaginationCount = res.headers.get('X-Pagination-Total-Count')

    })
  }

  addCarton(id,cartonid) {
    console.log(cartonid)
    // 1 is create and 2 is edit
    let crown_collection = {
      is_edit : 1,
      create : 0,
      whitelist : 0,
      points_config : 0,
      target : 0,
      campaign_id : ""
    } 
    localStorage.setItem("crown_collection" , JSON.stringify(crown_collection))   
    this.router.navigate(["/hubAdmin/crown-setup/0"])
  }
    
  editCarton(crown){
    let crown_collection = {
      is_edit : 1,
      create : 1,
      whitelist : crown.cwu_log,
      points_config : crown.cps_log,
      target : crown.ct_log,
      campaign_id : crown.id
    }
    localStorage.setItem("crown_collection" , JSON.stringify(crown_collection))   
    this.router.navigate(["/hubAdmin/crown-setup/"+crown.id])
  }
  

  
  get f() {
    return this.formGroup.controls;
  }
  dismissModal(){
    this.modalService.dismissAll();
    this.formGroup.reset();
    this.countError = false
    this.startDate = "";
  }
  getBrand(){
    this.apiService.get(this.apiConfig.getCartonBrand).subscribe((res :any)=>{
      console.log(res);
      this.brandList = res.data;
    })
  }

  paginationClick(e) {
    console.log(e);
    this.page = e;
    // this.getCartonList();
    this.getCrownList()
  }
  
}

